export default __webpack_public_path__ + "static/media/1.413671f3.jpg";